export var LoginRole;
(function (LoginRole) {
    LoginRole["SUPER_ADMIN"] = "SUPER_ADMIN";
    LoginRole["ADMIN"] = "ADMIN";
    LoginRole["USER"] = "USER";
    LoginRole["READ_ONLY"] = "READ_ONLY";
})(LoginRole || (LoginRole = {}));
//# sourceMappingURL=login-user-role.enum.js.map